export default defineNuxtPlugin(() => {
  return {
    provide: {
      scrollToHash: (hash: string) => {
        if (!hash || hash === '#') return;

        setTimeout(() => {
          const element = document.querySelector(hash);
          const headerElement = document.querySelector('#header');
          if (element) {
            const headerHeight = headerElement?.clientHeight || 0;
            const elementPosition =
              element.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
              top: elementPosition - headerHeight - 20,
              behavior: 'smooth',
            });
          }
        }, 300);
      },
    },
  };
});
